import type { ReactNode } from 'react'
import { Box } from '@mui/material'

import { tokens } from '@configuration/theme'

export interface DividerProps {
  dataTestId?: string
  children?: ReactNode
}

// Centered-text divider (`.divider`) — a hairline rule on each side of an
// uppercase label, e.g. "or with email".
const Divider = ({ dataTestId = 'divider', children }: DividerProps) => (
  <Box
    data-testid={dataTestId}
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      color: tokens.businessBlack40,
      fontSize: 12,
      letterSpacing: '0.3px',
      textTransform: 'uppercase',
      '&::before, &::after': {
        content: '""',
        flex: 1,
        height: '1px',
        background: tokens.borderDefault,
      },
    }}
  >
    {children}
  </Box>
)

export default Divider
